//
// TextlistMetadata
//
// Based on view info from a layout

import { observer } from 'mobx-react-lite'

import { Text } from '../../../../components'
import { LAYOUTCOMPONENTTYPECONFIG } from '../../../../stores/data/LAYOUTCOMPONENTTYPECONFIG'

export const TextlistMetadata = observer(function TextlistMetadata({
    className,
    name,
    field,
    value,
    language,
    component,
    renderkey,
}) {
    const config = LAYOUTCOMPONENTTYPECONFIG['metadata']

    let attributes = { className: 'layout-component ws-text' }
    if (className) attributes['className'] += ' ' + className
    const componentstyle = component.style
        ? component.style
        : config.typeconfig[field.type].style.default
    if (componentstyle) attributes['className'] += ' lc-' + componentstyle

    if (Array.isArray(value)) {
        if (componentstyle === 'bullets') {
            value = value.map((line, index) => <li key={index}>{line}</li>)
            value = <ul>{value}</ul>
        } else {
            value = value.join('\n')
        }
    }

    return <Text {...attributes}>{value}</Text>
})
